import { InertiaLink } from '@inertiajs/inertia-react';
import { useDebouncedCallback } from 'app/components/hooks/useDebouncedCallback';
import useSearch from 'app/components/hooks/useSearch';
import Img from 'app/components/Image';
import { ScreenContext } from 'app/components/ScreenContext';
import Icon from 'components/Icon'
import React, { Children, InputHTMLAttributes, useContext, useEffect, useRef, useState } from 'react'
import TSlideContainer from '../TSlideContainer';
import { ErrorGroupContext } from './ErrorGroup';
import { FormContext } from './Form'

interface Props<T> extends InputHTMLAttributes<HTMLInputElement> {
    // options: Array<{ text: string | any, value: string | number, element?: any }>
    keyName: string
    optionsCallback: (data: T) => { text: string, value: string | number, element?: any }
    placeholder?: string
    onChange?: any
    label?: string | any
    name?: string
    labelClassName?: string
    showPlaceholder?: boolean
    max?: number
    locale?: string
    exclude?: T
    onSelect?: any
    containerClass?: string
    delay?: number
    className?: string
    closeOnClick?: boolean
    forcedUp?:boolean
    labelContClass?: string
}


export function SearchCard({ name, image, href }) {
    return (
        <InertiaLink href={href} className=" rounded leading-4 px-16px hover:bg-gray-343434 bg-gray-1C1C1C py-8px cursor-pointer flex h-45px" >
            <div className="inline-flex  pr-16px items-center  rounded bg-opacity-50">
                {image && <div className="w-26px h-26px mr-12px overflow-hidden rounded-full"><Img className="object-cover object-center w-full h-full" src={image} alt={`${name} | Timea`} /></div>}
                <div>{name}</div>
            </div>
        </InertiaLink>
    );
}


function Suggestion(props) {

    const suggestions = useRef<HTMLDivElement>(null)
    const [upOrDown, setupOrDown] = useState(false)

    const isOutViewport = (element: HTMLDivElement | null) => {
        try {

            if (!element)
                return;

            var bounding = element.getBoundingClientRect();

            if (bounding.left < 0) {
                // Left side is out of viewoprt
            }

            if (bounding.bottom > (window?.innerHeight || document?.documentElement.clientHeight) && !upOrDown) {
                setupOrDown(true)
            }

            if (bounding.right > (window?.innerWidth || document?.documentElement.clientWidth)) {
                // Right side is out of viewport
            }

            if (bounding.top < 0) {
                // Top side is out of viewport
            }

            if(props.forcedUp){
                setupOrDown(true)
            }

        } catch (error) { }
    }

    useEffect(() => {
        isOutViewport(suggestions.current);
    }, [])

    return (
        <div ref={suggestions} onClick={props.closeOnClick ? () => props.lookup('q', '') : undefined} className={`overflow-hidden collapsable w-full absolute bg-gray-1C1C1C  shadow-sm border-gray-1C1C1C border z-99999 ${upOrDown ? `top-0 transform -translate-y-full border-b-0 rounded-t mt-6px` : "border-t-0 rounded-b  -mt-6px"} `}>
            {props.results.slice(0, 6).map((o, i) =>

                o.element ?? <div key={`option-${i}`} className="border-t leading-4 px-16px hover:bg-F8F2EB border-C4C4C4 py-8px cursor-pointer" >{o.text}</div>

            )}
        </div>
    );
}

function Search<T>(props: Props<T>) {
    const { placeholder, showPlaceholder = false, labelClassName, labelContClass, max = 999, forcedUp = false, className, onChange = (v) => { }, onSelect = (v) => { }, label, name = "select", keyName, optionsCallback, locale = 'cs', exclude, containerClass = "", delay, closeOnClick = false, ...rest } = props

    const { data, setData, errors, clearErrors } = useContext(FormContext)
    const {isMobile} = useContext(ScreenContext)
    const {seterrors} = useContext(ErrorGroupContext);
    useEffect(() => {
        seterrors(e => ({ ...e, [name]: errors[name] }))
    }, [errors[name]])

    const [res, search] = useSearch<T>(keyName, locale, delay);

    const { setData: lookup, data: lookupd } = search;

    const [selected, setselected] = useState<Array<{ text: string, value: string | number, element?: any }>>([])

    const [focused, setfocused] = useState(false)

    const add = (o) => {

        if ((data[name] ?? [])?.length < max) {
            setData(name, [...(data[name] ?? []), o.value])
            setselected(s => [...s, o])
            lookup('q', "");
        }

        setfocused(false);
    }

    const remove = (v) => {
        setData(name, data[name]?.filter(f => f != v))
        setselected(s => s.filter(f => f.value != v))
    }


    let options = res?.map ? (res?.map(data => optionsCallback(data))) : []

    let input = lookupd?.['q'];

    let results = options?.filter((o) => /* (o.text).toLowerCase().includes(input.toLowerCase()) &&  */!(data?.[name]?.includes(o.value)) && !(exclude && (o.value == optionsCallback(exclude).value)));

    return (
        <label className={`w-full flex flex-col box-border ${labelContClass ? labelClassName : 'ssm:max-w-200px '}`} >
            <div className={`${labelClassName}`}>{label}</div>
            <div className={`relative `}>
                <div className={`border border-gray-1C1C1C rounded bg-gray-1C1C1C  placeholder-gray-343434 h-55px flex box-border w-full items-center px-19px  overflow-x-auto overflow-y-hidden tagscrollbar ${containerClass}`}>
                    <div className="flex">
                        {/* {
                            data[name]?.map(v =>
                                <div className="mr-8px flex items-center relative whitespace-nowrap">
                                    {
                                        [...selected, ...options].find(o => o.value == v)?.element ?? <div className="py-6px px-8px pr-16px bg-bg border border-C4C4C4 rounded-sm"> {selected.find(o => o.value == v)?.text} </div>
                                    }
                                    <Icon className="absolute right-3px top-3 rounded-full p-3px text-black h-20px cursor-pointer" name="cross-small" onClick={() => remove(v)} />
                                </div>
                            )
                        } */}
                    </div>
                    {
                        ((data[name] ?? [])?.length < max) &&
                        <input
                            className={` outline-none bg-gray-1C1C1C flex-grow ${className}`}
                            type="text"
                            placeholder={placeholder ?? "Hledejte..."}
                            autoComplete="chrome-off"
                            {...rest}
                            name={name}
                            value={lookupd['q']}
                            onChange={e => { lookup('q', e.target.value); clearErrors(name); setData(name, e.target.value) }}
                            onFocus={() => setfocused(true)}
                            onBlur={() => {
                                setTimeout(() => {
                                    setfocused(false)
                                }, 200);
                            }}
                        />
                    }
                </div>

                {
                    (input?.length > 0 && focused) &&
                    <Suggestion results={results} lookup={lookup} closeOnClick={closeOnClick} forcedUp={forcedUp?true:false} />
                }
            </div>
            <div className={`h-12px mt-4px text-12 text-C86B28 ${errors[name] ? "" : "opacity-0"}`}>{errors?.[name]}</div>
        </label>
    )
}

export default Search
